export let UserSizeOption;
(function (UserSizeOption) {
  UserSizeOption["One"] = "1-user";
  UserSizeOption["Two"] = "2-users";
  UserSizeOption["ThreeToFive"] = "3-to-5-users";
  UserSizeOption["SixToTen"] = "6-to-10-users";
  UserSizeOption["ElevenToTwentyFive"] = "11-to-25-users";
  UserSizeOption["TwentySixToFifty"] = "26-to-50-users";
  UserSizeOption["FiftyOneToTwoHundred"] = "51-to-200-users";
  UserSizeOption["TwoHundredOneToFiveHundred"] = "201-to-500-users";
  UserSizeOption["FiveHundredOneOrMore"] = "501-or-more";
})(UserSizeOption || (UserSizeOption = {}));
export const userSizeAttributesMap = {
  [UserSizeOption.One]: {
    label: '1'
  },
  [UserSizeOption.Two]: {
    label: '2'
  },
  [UserSizeOption.ThreeToFive]: {
    label: '3 to 5'
  },
  [UserSizeOption.SixToTen]: {
    label: '6 to 10'
  },
  [UserSizeOption.ElevenToTwentyFive]: {
    label: '11 to 25'
  },
  [UserSizeOption.TwentySixToFifty]: {
    label: '26 to 50'
  },
  [UserSizeOption.FiftyOneToTwoHundred]: {
    label: '51 to 200'
  },
  [UserSizeOption.TwoHundredOneToFiveHundred]: {
    label: '201 to 500'
  },
  [UserSizeOption.FiveHundredOneOrMore]: {
    label: '501 or more'
  }
};